module.exports = __webpack_public_path__ + "img/kyara_popup3.8360b8ee.png";